import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "lineBreaks",
  standalone: true,
})
export class LineBreaksPipe implements PipeTransform {
  public transform(value: string): string {
    if (!value) return "";
    return value
      .split("\n\n")
      .map((p) => `<p>${p.replace(/\n/g, "<br>")}</p>`)
      .join("");
  }
}
